import { connect } from 'react-redux';
import ProductIconComponent from './ProductIcon';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productManifest = state.productManifest;
  var iconFileName = ownProps.iconFileName;
  var size = ownProps.size || 48;
  return {
    productManifest: productManifest,
    iconFileName: iconFileName,
    size: size
  };
};
export default connect(mapStateToProps)(ProductIconComponent);